import ContentLoader from 'react-content-loader';
import React from 'react';

//can be created from here: http://danilowoz.com/create-content-loader/
const SkeletonLoader = () => (
  <ContentLoader
    height={400}
    width={400}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="0" y="18" rx="3" ry="3" width="100" height="20" />
    <rect x="41" y="50" rx="3" ry="3" width="37" height="8" />
    <rect x="0" y="50" rx="3" ry="3" width="37" height="8" />
    <rect x="0" y="107" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="137" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="167" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="197" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="227" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="257" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="287" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="317" rx="3" ry="3" width="368" height="10" />
    <rect x="0" y="347" rx="3" ry="3" width="368" height="10" />
  </ContentLoader>
);

export default SkeletonLoader;
